// extracted by mini-css-extract-plugin
module.exports = {"input":"room__styles__input___1VpS0Q","text":"room__styles__text___38LyeO","hidden":"room__styles__hidden___3PNYNB"};